import React, { Component } from 'react';

import SearchFormCommon from './searchForm_common';
import SearchFormHeader from './components/searchFormHeader';

class SearchFormBW extends Component {
    render() {
        return (
            <div>
                <SearchFormHeader headerTitle="B&W" formType={this.props.formType} /> 
                <SearchFormCommon {...this.props} />             
            </div>
        );
    }
}

export default SearchFormBW;


// WEBPACK FOOTER //
// ./src/components/searchForm/searchForm_bw.js